import { CalendarEntity, ComponentCommonDays } from '@/graphql/generated/graphql';
import { months } from './months-list';

export const splitCalendarByMonth = (calendar: CalendarEntity | null) => {
  const monthsWithEvents: { month: string; events: ComponentCommonDays[] }[] = Array.from({ length: 12 }, (_, i) => ({
    month: months[i],
    events: [],
  }));

  if (!calendar?.attributes?.eventDays) return monthsWithEvents;

  calendar.attributes.eventDays.forEach((event) => {
    const startDate = new Date(event?.startDate);
    const endDate = event?.endDate ? new Date(event?.endDate) : startDate;

    let currentMonth = startDate.getMonth();
    const lastMonth = endDate.getMonth();

    while (currentMonth <= lastMonth) {
      monthsWithEvents[currentMonth].events.push(event as ComponentCommonDays);
      currentMonth++;
    }
  });

  return monthsWithEvents;
};
